// @flow
import React, { PureComponent } from 'react';
import type { EventType, EventMatchType } from 'types/Event';
import EventListElementWrapper from 'containers/event/EventListElementWrapperContainer';
import HiddenEventListElement from 'components/event/HiddenEventListElement';

type Props = {
  events: Array<EventType | EventMatchType>,
  from?: string,
};

class EventListRow extends PureComponent<Props> {
  props: Props;

  renderFirstEvents = (number: number): any => {
    const { events, from } = this.props;

    return events
      .slice(0, number)
      .map((event, index) => (
        <EventListElementWrapper key={index} event={event} isFirst={index === 0} from={from} />
      ));
  };

  render() {
    const { events, from } = this.props;

    if (events.length === 0) return null;
    if (events.length === 1) return <EventListElementWrapper event={events[0]} from={from} isFirst />;
    if (events.length === 2) return <div className="events__group">{this.renderFirstEvents(2)}</div>;

    return (
      <div className="events__group">
        {this.renderFirstEvents(2)}
        <HiddenEventListElement events={events.slice(2)} />
      </div>
    );
  }
}

export default EventListRow;
